import {
  Divider,
  List,
  ListItem,
  ListItemText,
  Dialog,
  DialogActions,
  DialogTitle,
  Button,
  Typography,
  TextField,
  MenuItem,
} from '@material-ui/core';
import { map } from 'rxjs/operators';
import { useBoolean } from '@lib/common';
// import { Fragment, memo, useEffect } from 'react';
import React, { Fragment, useEffect, useCallback, memo, useMemo, useRef, useState } from 'react';
import { useFormContext, useWatch, useController } from 'react-hook-form';
import { Observable, Subscription } from 'rxjs';
import { BadgesMaster } from '@api/masters';
import styled from 'styled-components';
import getLoadingMessage from '@lib/common/loading-messages';
import { Autocomplete } from '@material-ui/lab';
import { createFilterOptions } from '@material-ui/lab/Autocomplete';
import { debounce } from 'lodash';
import MovieCreationIcon from '@material-ui/icons/MovieCreation';
import OfflinePinIcon from '@material-ui/icons/OfflinePin';
import * as personService from '@api/person';
import CircularProgress, { CircularProgressProps } from '@material-ui/core/CircularProgress';
import {
  Grid,
  InputLabel,
  Select,
  FormControl,
  Box,
  Chip,
  Link,
  Tooltip,
  Avatar,
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import Fab from '@material-ui/core/Fab';
import { ColoredChipIconButton } from '@components/colored-elements';
import { grey, red } from '@material-ui/core/colors';
import { BiEdit, ImDrawer2, TrashFill } from '@icon/react-icons';
import { useSnackbarInstance } from '@lib/common';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { AssociatedPersonSearch } from 'pages/company/form/fields/company-associated-person/AssociatedPersonSearch';
import { useSnackbar } from 'notistack';
import * as designationService from '@api/person/designation';
import * as companyService from '@api/person/company-search';

import { HelperTextTip } from '@components/hepler-text-tip';
import FormHelperText from '@material-ui/core/FormHelperText';

export const AssociatedPersonDialogContent = memo<any>(
  ({ saveAssociatedPerson, defaultValue, OkPressed, setOkPressed }) => {
    // console.log(defaultValue, 'defaultValue2222');
    const [associatedPerson, setAssociatedPerson] = useState(
      defaultValue
        ? defaultValue.vtr_id
          ? {
            name: defaultValue.name,
            vtr_id: defaultValue.vtr_id ? defaultValue.vtr_id : defaultValue.person_vtr_id,
            company_name: defaultValue.company,
            person_vtr_id: defaultValue.person_vtr_id ? defaultValue.person_vtr_id : defaultValue.vtr_id,
          }
          : defaultValue.person_vtr_id
            ? {
              name: defaultValue.name,
              vtr_id: defaultValue.vtr_id ? defaultValue.vtr_id : defaultValue.person_vtr_id,
              company_name: defaultValue.company,
              person_vtr_id: defaultValue.person_vtr_id ? defaultValue.person_vtr_id : defaultValue.vtr_id,
            }
            : null
        : null
    );

    const [company, setCompany] = useState(
      defaultValue ? (defaultValue.company ? { company: defaultValue.company } : null) : null
    );
    const [associatedCompany, setAssociatedCompany] = useState(
      defaultValue
        ? defaultValue.company_name
          ? [{ company: defaultValue.company, company_vtr_id: defaultValue.company_vtr_id, name: defaultValue.company }]
          : null
        : null
    );
    const [associatedDesignation, setAssociatedDesignation] = useState(
      defaultValue
        ? defaultValue.designation
          ? {
            designation: defaultValue.designation,
          }
          : null
        : null
    );

    useEffect(() => {
      if (OkPressed) {
        const saveAssociatedPersonDetails = {
          ...(typeof associatedPerson === 'string'
            ? { name: associatedPerson, vtr_id: null }
            : {
              name: associatedPerson ? associatedPerson.name : null,
              vtr_id: associatedPerson ? associatedPerson.person_vtr_id : null,
              company: company ? company.company : null,
              company_name: (associatedCompany?.length > 0) ? associatedCompany[0].name : 'NA'
            }),
          ...(typeof company === 'string'
            ? { company: company }
            : {
              company: company ? company.company : null,
            }),
          ...(typeof associatedCompany === 'string'
            ? { company_name: company, company_vtr_id: null }
            : {
              company_name: (associatedCompany?.length > 0) ? associatedCompany[0].name : null,
            }),
          // ...(typeof associatedCompany != 'string'
          //   ? { company_name: associatedCompany ? associatedCompany[0].name : 'NA', company_vtr_id: null }
          //   : {
          //       company_name: company ? company.company : null,
          //     }),
          ...(typeof associatedDesignation === 'string'
            ? { designation: associatedDesignation }
            : {
              designation: associatedDesignation ? associatedDesignation['designation'] : null,
            }),
        };
        if (associatedPerson) saveAssociatedPerson(saveAssociatedPersonDetails);
        // if (associatedCompany) saveAssociatedPerson(saveAssociatedPersonDetails);
        // if (associatedDesignation) saveAssociatedPerson(saveAssociatedPersonDetails);

        setOkPressed(false);
      }
    }, [OkPressed]);
    return (
      <>
        <Typography variant="subtitle1">Associated Person</Typography>
        <br />
        <ControlledAutoCompleteField
          associatedPerson={associatedPerson}
          setAssociatedPerson={setAssociatedPerson}
          associatedCompany={associatedCompany}
          setAssociatedCompany={setAssociatedCompany}
          company={company}
          setCompany={setCompany}
        />
        <br />

        <Typography variant="subtitle1">Designation</Typography>
        <br />
        <ControlledAutoCompleteDesignationField
          associatedDesignation={associatedDesignation}
          setAssociatedDesignation={setAssociatedDesignation}
        />
      </>
    );
  }
);

export const ControlledAutoCompleteField = ({
  associatedPerson,
  setAssociatedPerson,
  associatedCompany,
  setAssociatedCompany,
  company,
  setCompany,
  createCompanyRelation=false,
  ...props
}) => {
  const [personObj, setPersonObj] = React.useState({});
  const [loadingCompanies, setLoadingCompanies] = React.useState(false);
  useEffect(() => {
    if (associatedPerson?.vtr_id || associatedPerson?.person_vtr_id) {
      getOptionsData();
    }
  }, [associatedPerson]);

  const getOptionsData = () => {

    if (associatedPerson) {
      setLoadingCompanies(true)
      companyService
        .companySearch({
          person_vtr_id: associatedPerson.person_vtr_id
        })
        .pipe(
          map(res => ({
            ...res.data,
            data: res.data,
          }))
        )
        .subscribe({
          next: data => {
            setAssociatedCompany(data.data);
          },
          error: data => {
            console.error(data, 'Error');
          },
          complete: () => {
            setLoadingCompanies(false)
          },
        });
    }
  };
  // ControlledAutoCompleteCompanyField({associatedCompany: associatedCompany, setAssociatedCompany:setAssociatedCompany, associatedPerson:associatedPerson})
  return (
    <AssociatedPersonSearch
      associatedPerson={associatedPerson}
      setAssociatedPerson={setAssociatedPerson}
      associatedCompany={associatedCompany}
      setAssociatedCompany={setAssociatedCompany}
      company={company}
      setCompany={setCompany}
      freeSolo={false}
      showCompany={true}
      loadingCompanies={loadingCompanies}
      createCompanyRelation={createCompanyRelation}
    />
  );
};

export const ControlledAutoCompleteDesignationField = ({
  associatedDesignation,
  setAssociatedDesignation,
  createCompanyRelation = false,
  ...props
}) => {
  const [options, setOptions] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [open, setOpen] = React.useState(false);

  useEffect(() => {
    getOptionsData();
  }, []);

  const getOptionsData = () => {
    setLoading(true);
    designationService
      .designationSearch({})
      .pipe(
        map(res => ({
          ...res.data,
          data: res.data,
        }))
      )
      .subscribe({
        next: data => {
          setOptions(data.data);
        },
        error: data => {
          console.error(data, 'Error');
        },
        complete: () => {
          setLoading(false);
        },
      });
  };

  const DesignationAutocomplete = ({ value, onChange }) => {
    // const { loading, master: languages } = usePintMaster('languages');
  
    return (
      // <GenreStyles>
      <Autocomplete
        size="small"
        value={associatedDesignation?.designation}
        defaultValue={associatedDesignation?.designation}
        onChange={(evt, v) => onChange && onChange(v)}
        loading={loading}
        disabled={loading}
        options={options || []}
        getOptionLabel={value => value.name}
        renderInput={props => (
          <TextField
            helperText="Select a Designation"
            label={'Select a Designation'}
            // placeholder={Select a Designation}
            fullWidth
            // variant="outlined"
            {...props}
          />
        )}
      />
      // </GenreStyles>
    );
  };
  return (
    
    <>
      <FormControl variant="outlined" fullWidth>
        {/* <InputLabel id="designation-label">{loading ? 'Loading designations...' : 'Selet a designation'}</InputLabel> */}
        {/* <DesignationAutocomplete /> */}
        {/* {console.log({"options": options})} */}
        
        <Autocomplete
          size="small"
          freeSolo
          value={associatedDesignation?.designation}
          filterOptions={createFilterOptions({
            matchFrom: 'start',
            stringify: option => option,
          })}
          defaultValue={associatedDesignation?.designation}
          // onChange={(evt, v) => onChange && onChange(v)}
          onChange={(event: any, newValue: string | null) => {
            // console.log({ "target": event.target.value });
            // console.log({ "newValue": newValue })
            setAssociatedDesignation(newValue);
            // (newValue);
          }}
          loading={loading}
          disabled={loading}
          options={options || []}
          // options={options.sort((a, b) =>
          //   b.toString().localeCompare(a.toString())
          // )}
          getOptionLabel={value => value}
          renderInput={props => (
            <TextField
              helperText={createCompanyRelation ? "" : "Select a Designation"}
              label={loading ? 'Loading designations...' : 'Select a designation'}
              // placeholder={Select a Designation}
              fullWidth
              variant="outlined"
              {...props}
            />
          )}
        />

        {/* <Select
          labelId="designation-label"
          id="designation"
          name="designation"
          native
          label="Select a Designation"
          disabled={loading}
          value={associatedDesignation?.designation}
          defaultValue={associatedDesignation?.designation}
          onChange={e => setAssociatedDesignation(e.target.value)}>
          <option value=""></option>
          {options.map(res => (
            // console.log(res, associatedDesignation.designation)
            <option key={res} value={res}>
              {res}
            </option>
          ))}
        </Select> */}
      </FormControl>
      <br />
      <br />
      Designation not available? <Link component="button" color="primary" onClick={() => setOpen(true)}>
        Create New
      </Link>
      <DealDesignationDialog
        open={open}
        onClose={() => setOpen(false)}
        getOptionsData={getOptionsData}
      />
    </>
  );
};

export function DealDesignationDialog({
  onDeleteFinish = null,
  onClose = null,
  open,
  getOptionsData = null,
}) {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const form = useFormContext();
  const [designation, setDesignation] = useState('');
  const classes = useStyles();
  const ClickHandler = () => {
    if (designation !== '') {
      designationService
        .newDesignation({
          designation_name: designation,
        })
        .pipe(
          map(res => ({
            ...res.data,
            data: res.data,
          }))
        )
        .subscribe({
          next: data => {
            onClose();
            getOptionsData();
          },
          error: err => {
            if (err?.response?.status === 409) {
              onClose();
              return enqueueSnackbar('A Designation is already exist. Please select a value from dropdown!', { variant: 'success', autoHideDuration: 7000 });
            }
          },
          complete: () => {
            onClose();
          },
        });
    }
  };
  return (
    <Dialog
      classes={{ paper: classes.paper }}
      maxWidth="lg"
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description">
      <DialogTitle id="alert-dialog-title">Enter the Designation</DialogTitle>
      <FormControl className={classes.inputF} variant="outlined">
        <TextField
          label="Enter Designation"
          placeholder="Enter Designation"
          variant="outlined"
          value={designation}
          onChange={e => setDesignation(e.target.value)}
          inputRef={form.register}
        />
        <DialogActions>
          <Button onClick={ClickHandler} color="primary" autoFocus>
            Save
          </Button>
          <Button onClick={onClose} color="primary">
            Cancel
          </Button>
        </DialogActions>
      </FormControl>
    </Dialog>
  );
}

// const StyledDialog = styled(Dialog)`
//   & .MuiDialog-paperScrollPaper {
//     max-height: calc(100%);
//   }
// `;

const useStyles = makeStyles(() => ({
  paper: { minWidth: '500px', margin: '10px' },
  inputF: {
    margin: '20px',
    width: '450px',
  },
}));